import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["filled", "width", "height", "fill", "backgroundColor"];
import React from 'react';

var getPath = function getPath(filled) {
  if (filled) return 'M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5zM8.03 11.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0-1.06-1.06l-5.47 5.47-2.47-2.47z';
  return 'M12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5zm0-1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-3.97-9.53l2.47 2.47 5.47-5.47a.75.75 0 0 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06z';
};

var AvailableIcon = function AvailableIcon(_ref) {
  var _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), backgroundColor && /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("path", {
    d: getPath(filled)
  }));
};

AvailableIcon.displayName = 'AvailableIcon';
export default AvailableIcon;